module.exports = __webpack_public_path__ + "static/media/embdBk.d3f492a9.jpeg";